import { sendRequest } from "../axios";
export default {
  state: {
    organisationAgent: {
      inn: "",
      kpp: "",
      orgShortName: "",
      jurrAddr: ""
    },
    gotOrganisationAgent: false,
    myOrganization: {
      id: null,
      inn: null,
      orgShortName: null
    }
  },
  mutations: {
    SET_ORGANIZATION_AGENT(state, commit) {
      state.organisationAgent = commit;
    },
    SET_ORGANIZATION_AGENT_PARAM(state, payload) {
      state.organisationAgent[payload.param] = payload.value;
    },
    SET_GOT_ORGANIZATION_AGENT(state, commit) {
      state.gotOrganisationAgent = commit;
    },
    SET_MY_ORGANIZATION(state, payload) {
      state.myOrganization = payload;
    }
  },
  actions: {
    getAgentFirm({ commit }) {
      return new Promise(resolve => {
        commit("SET_PROCESSING", true);
        sendRequest("getAgentFirm", "get").then(response => {
          commit("SET_ORGANIZATION_AGENT", response.data.userFirm);
          commit("SET_GOT_ORGANIZATION_AGENT", true);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    MyOrgInfoShort({ commit }) {
      commit("SET_PROCESSING", true);
      return new Promise((resolve, reject) => {
        sendRequest("MyOrgInfoShort", "get").then(response => {
          const firm = response.data.userFirm;
          const regOOO =  /ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ/i
          const regIP = /Индивидуальный предприниматель/i
          const regSam = /Самозанятый\s/;
          if (regSam.test(firm.orgShortName)) {
            const name = String(firm.orgShortName)
              .replace(regSam, "")
              .split(/\s|\s+/g);

            let newName = "";
            if (name.length == 2) {
              newName = `Самозанятый ${name[0]} ${name[1].slice(0, 1)}.`;
            }
            if (name.length == 3) {
              newName = `Самозанятый ${name[0]} ${name[1].slice(
                0,
                1
              )}. ${name[2].slice(0, 1)}.`;
            }
            firm.orgShortName = newName;
          }

          if(regOOO.test(firm.orgShortName)){
            firm.orgShortName = firm.orgShortName.replace(regOOO, 'OOO')
          }

          if(regIP.test(firm.orgShortName)){
            firm.orgShortName = firm.orgShortName.replace(regIP, 'ИП')
          }

          commit("SET_MY_ORGANIZATION", firm);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    updateAgentFirm({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("updateAgentFirm", "post", data).then(response => {
          commit("SET_ORGANIZATION_AGENT", response.data.userFirm);
          commit("SET_GOT_ORGANIZATION_AGENT", true);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    }
  },
  getters: {
    getOrganisationAgent: state => state.organisationAgent,
    getGotOrganisationAgent: state => state.gotOrganisationAgent,
    getMyOrganisation: state => state.myOrganization
  }
};
